import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { http, formatApiError } from "@/lib/api";
import { useRealtimeEvent } from "@/context/RealtimeContext";

export const SettingToggle = ({ field, label, shortLabel, onMsg, offMsg, testId }) => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => http.get("/admin/settings").then(({ data }) => setOn(!!data[field])).catch(() => {}), [field]);
  useEffect(() => { load(); }, [load]);
  useRealtimeEvent((m) => { if (m.event === "settings.updated" || m.event === "resync") load(); });

  const change = async (v) => {
    setBusy(true);
    try {
      await http.put("/admin/settings", { [field]: v });
      setOn(v);
      toast.success(v ? onMsg : offMsg);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className={`flex cursor-pointer items-center gap-2 rounded-md border px-2.5 py-1 text-xs transition-colors ${on ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-white/10 text-slate-400"}`} data-testid={`${testId}-label`}>
      <span className="hidden 2xl:inline">{label}</span>
      <span className="2xl:hidden">{shortLabel}</span>
      <Switch checked={on} disabled={busy} onCheckedChange={change} data-testid={testId} />
    </label>
  );
};

export const OnlineServiceToggle = () => (
  <SettingToggle field="online_service" label="Atendimento Online" shortLabel="Atendimento" testId="online-service-toggle"
    onMsg={'Atendimento Online ativado: clientes verão apenas "Resgatar agora".'} offMsg="Atendimento Online desativado: agendamento liberado." />
);

export const DocumentValidationToggle = () => (
  <SettingToggle field="document_validation" label="Validar CPF/CNPJ" shortLabel="Validação" testId="document-validation-toggle"
    onMsg="Validação ativada: cada CPF/CNPJ aguardará sua aprovação." offMsg="Validação desativada: o atendimento segue direto." />
);

export const SystemOnlineToggle = () => (
  <SettingToggle field="system_online" label="Sistema online" shortLabel="Sistema" testId="system-online-toggle"
    onMsg="Sistema online: o portal voltou a funcionar." offMsg="Sistema offline: o portal foi desativado para os clientes." />
);
